var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-legend-percentage action white--text",class:[_vm.colorData.colorClasses],style:([_vm.colorData.colorStyles])},[_vm._v(" "+_vm._s(_vm._f("roundNumber")(_vm.value,0))+" % ")])
}
var staticRenderFns = []

export { render, staticRenderFns }